import { useTranslations } from "contexts/LocalizationContext";
import { Flex, Heading, Text } from "@chakra-ui/react";
import Card from "./Card";
import ScoreTag from "../ScoreTag";
import type { BestAirlinesProps } from "./BestAirlines.d";

const BestAirlinesByRegion = ({ airlinesRegions }: Pick<BestAirlinesProps, "airlinesRegions">) => {
  const translations = useTranslations();

  return (
    <Card>
      <Heading variant="h3" as="h3" mb={5}>
        {translations("best_airlines_by_region")}
      </Heading>

      {airlinesRegions.map((airline) => {
        const { airline: name, score, region } = airline;
        return (
          <Flex
            key={region}
            justifyContent="space-between"
            alignItems="center"
            fontSize="sm"
            borderBottom="1px"
            borderColor="greyscale.300"
            py={4}
            position="relative"
            _last={{ borderBottom: "none", pb: 0 }}
          >
            <Flex>
              <Text fontSize="sm" minW={{ base: "150px", md: "250px", lg: "200px" }}>
                {translations(region)}
              </Text>
              <Text fontSize="sm">{name}</Text>
            </Flex>
            <ScoreTag index={0} score={score} />
          </Flex>
        );
      })}
    </Card>
  );
};
export default BestAirlinesByRegion;
